import React from 'react';
import IconButtonWhiteBg from '../../../common/IconButtonWhiteBg';
import { useAtom } from 'jotai';
import { reviewEnablePhrasifierAtom } from '../../../../atoms/spreadsheet-atoms';
import ViewStreamIcon from '@mui/icons-material/ViewStream';

const IconTogglePhrasifier: React.FC = () => {
  const [reviewEnablePhrasifier, setReviewEnablePhrasifier] = useAtom(reviewEnablePhrasifierAtom);

  const handleToggle = () => {
    setReviewEnablePhrasifier(!reviewEnablePhrasifier);
  };

  return (
    <IconButtonWhiteBg
      disabled={false}
      onClick={handleToggle}
      id="icon-toggle-phrasifier"
      cypressId="icon-toggle-phrasifier"
      tooltip={reviewEnablePhrasifier ? 'Disable Phrasifier' : 'Enable Phrasifier'}
      sx={{
        backgroundColor: reviewEnablePhrasifier ? '#1D9AAA' : 'white',
        '&:hover': {
          backgroundColor: reviewEnablePhrasifier ? '#187787' : '#f0f0f0',
        },
      }}
    >
      <ViewStreamIcon
        style={{
          fontSize: '14px',
          color: reviewEnablePhrasifier ? 'white' : 'black',
        }}
      />
    </IconButtonWhiteBg>
  );
};

export default IconTogglePhrasifier;
